module.exports = __webpack_public_path__ + "media/images/soar/site/icons/icon_2-b9ab686ca80ceff27e75297293443499.svg";